import { API } from '@aws-amplify/api'

import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'
import {
  addReportingInfo,
  updateFetchReportingDataInProgress,
  addLoadBalanceLogInfo,
  updateFetchLoadBalanceLogInProgress,
  addQCLogInfo,
  updateFetchQCLogInProgress,
  addReportUploadLogInfo,
  updateFetchReportUploadLogInProgress,
} from '../actions'

interface SearchRequest {
  user_id: string | null
  start_date?: string
  end_date?: string
  pageIndex: number | 1
  pageSize: number | 10
}

export const fetchReportingData =
  ({ user_id, start_date, end_date, pageIndex, pageSize }: SearchRequest) =>
  async (dispatch) => {
    try {
      const apiName = '/case-management/labmanager/get-reporting-info'
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          startdate: start_date,
          enddate: end_date,
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
        },
      }
      dispatch(updateFetchReportingDataInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${user_id}`, options)

      if (result?.data) {
        dispatch(addReportingInfo({ payload: result, userId: user_id }))
      }
    } catch (err) {
      console.log('fetchReportingData Error', err)
    } finally {
      dispatch(updateFetchReportingDataInProgress(false))
    }
  }

export const fetchLoadBalancerLog =
  ({ user_id, pageIndex, pageSize }: SearchRequest) =>
  async (dispatch) => {
    try {
      const apiName = '/case-management/lb_status'
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          batch_type: 'PrimaryDiagnosysLoadBalancer',
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
        },
      }
      dispatch(updateFetchLoadBalanceLogInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)

      if (result?.data) {
        dispatch(addLoadBalanceLogInfo({ payload: result, userId: user_id }))
      }
    } catch (err) {
      console.log('fetchReportingData Error', err)
    } finally {
      dispatch(updateFetchLoadBalanceLogInProgress(false))
    }
  }

export const fetchQCAssignmentLog =
  ({ user_id, pageIndex, pageSize }: SearchRequest) =>
  async (dispatch) => {
    try {
      const apiName = '/case-management/reports/qc_lb_status'
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
        },
      }
      dispatch(updateFetchQCLogInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)

      if (result?.data) {
        dispatch(addQCLogInfo({ payload: result, userId: user_id }))
      }
    } catch (err) {
      console.log('fetchReportingData Error', err)
    } finally {
      dispatch(updateFetchQCLogInProgress(false))
    }
  }

export const fetchReportUploadLog =
  ({ user_id, pageIndex, pageSize }: SearchRequest) =>
  async (dispatch) => {
    try {
      const apiName = '/case-management/reports/report_upload_status'
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
        },
      }
      dispatch(updateFetchReportUploadLogInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)

      if (result?.data) {
        dispatch(addReportUploadLogInfo({ payload: result, userId: user_id }))
      }
    } catch (err) {
      console.log('fetchReportingData Error', err)
    } finally {
      dispatch(updateFetchReportUploadLogInProgress(false))
    }
  }
